import cn from 'classnames';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';

import type { TBenefitsDefaultMobile, TBenefitsDefaultDesktop } from '../models';
import { renderButtons } from '../utils/render-buttons';

/**
 * Возвращает секции-бенефиты.
 */
export const ComponentDesktop = (props: TBenefitsDefaultDesktop) => {
    const { Grid, benefits, className, dataTestId, renderBenefit, styles } = props;
    // Если 4й элемент в Преимуществах кнопка - для неё нужен css-класс:
    /* istanbul ignore next */
    const isLastBenefitIsButton = (benefits[3] || {}).type === 'button';
    const colClassNames = cn(styles.wrap, styles.external, styles.col, {
        [styles.button]: isLastBenefitIsButton,
    });

    return (
        <div className={cn(styles.benefits, className)} data-test-id={dataTestId}>
            <Grid
                alignment
                classNames={{
                    col: colClassNames,
                    grid: cn(styles.wrap, styles.grid, styles.external),
                }}
                justify="between"
            >
                {benefits.map((benefit, i) => renderBenefit(props, benefit, i))}
            </Grid>
        </div>
    );
};

export const ComponentMobile: FC<PropsWithChildren<TBenefitsDefaultMobile>> = props => {
    const { Grid, benefits, children, className, dataTestId, relative, renderBenefit, styles } =
        props;
    const colClassNames = cn(styles.wrap, styles.external, styles.col);
    const { buttons } = useNamedContainers(children);

    return (
        <div
            className={cn(styles.benefits, className, { [styles.relative]: relative })}
            data-test-id={dataTestId}
        >
            <Grid
                alignment
                classNames={{
                    col: colClassNames,
                    grid: cn(styles.wrap, styles.grid, styles.external),
                }}
                flexDirection="column"
                justify="between"
            >
                {benefits.map((benefit, i) => renderBenefit(props, benefit, i))}
            </Grid>
            {buttons && <div className={styles.buttons}>{renderButtons(buttons, props)}</div>}
        </div>
    );
};
